module.exports = __webpack_public_path__ + "img/DW365-034.88680083.jpg";